import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DefaultCheckbox } from '../../../../components/Checkbox';
import { FormControlLabel, RadioGroup } from '@material-ui/core';
import apiCall from '../../../../data/app/apiCall';

import * as actions from './../../../../data/bidClasses/actions';

import CustomSlider from '../../../../components/CustomSlider';
import { RadioButton } from '../../../../components/Buttons/Buttons';
import { withStyles } from '@material-ui/core';
import { useLanguage } from '../../../../context/LanguageContext';

import './styles.scss';

function useIsMounted() {
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}

// Helper functions to avoid code duplication for crew group default logic
const getCategoryId = (isCrewGroupDefault, bidSession) => 
  isCrewGroupDefault ? 0 : bidSession.user.currentCategory.categoryId;

const getStaffId = (isCrewGroupDefault, bidSession) => 
  isCrewGroupDefault ? 'Admin' : bidSession.user.staffId;

const StyledRadioButton = withStyles({
  root: {
    display: props => (props.hidden ? 'none' : 'inline-flex'),
  },
})(RadioButton);

const BidClasses = (props) => {
  const { labels } = useLanguage();
  const commonLabels = labels.commonLabels || {};
  const RESERVE_DOWN = labels.RESERVE_DOWN || {};
  const isMounted = useIsMounted();
  const [slideIndex, setSlideIndex] = useState(0);
  const [displayReserveApi, setDisplayReserveApi] = useState(false);
  const [classOption, setClassOption] = useState(props.classOption);

  useEffect(() => {
    if(props.editPrefFromCombinedPreferenceOptionId) {
      setClassOption(props.editPrefFromCombinedPreferenceOptionId)
    }

    else if(props.editPrefFromCombinedPreferenceOptionId && props.classOption){
      setClassOption(props.classOption);
    }
    else {
      setClassOption(props.classOption);
      apiCall('preferences/displayEnabled?feature=conditional').then(res => {
        setDisplayReserveApi(res.data);
      })
    }
  }, [props.classOption, props.editPrefFromCombinedPreferenceOptionId]);

  useEffect(() => {
    const scrollTop = props.scrollTop;
    const target = document.getElementsByClassName('bid-class-tab-content')[props.slideIndex];
    if (target) {
      target.scrollTop = scrollTop;
    }
    setSlideIndex(props.slideIndex);

    const bidSession = props.bidSession ? props.bidSession : {};
    const applicationType = commonLabels.APPLICATION_TYPE;
    const optionPropertyId = props.optionPropertyId;
    const bidSessionId = bidSession.currentBid.bidSessionId;
    const { fetchBidPreferenceClasses, openCombinedPreferences, isCrewGroupDefault } = props;

    fetchBidPreferenceClasses(
      applicationType,
      optionPropertyId,
      getCategoryId(isCrewGroupDefault, bidSession),
      bidSessionId,
      getStaffId(isCrewGroupDefault, bidSession),
      openCombinedPreferences,
      () => isMounted.current
    );
  }, [props.slideIndex, props.scrollTop, props.bidSession, props.optionPropertyId, props.fetchBidPreferenceClasses, props.isCrewGroupDefault]);

  useEffect(() => {
    const bidSession = props.bidSession ? props.bidSession : {};
    const applicationType = commonLabels.APPLICATION_TYPE;
    const optionPropertyId = props.optionPropertyId;
    const bidSessionId = bidSession.currentBid.bidSessionId;
    const { fetchBidPreferenceClasses, openCombinedPreferences, isCrewGroupDefault } = props;

    fetchBidPreferenceClasses(
      applicationType,
      optionPropertyId,
      getCategoryId(isCrewGroupDefault, bidSession),
      bidSessionId,
      getStaffId(isCrewGroupDefault, bidSession),
      openCombinedPreferences,
      () => isMounted.current
    );
  }, [props.optionPropertyId, props.bidSession, props.fetchBidPreferenceClasses, props.isCrewGroupDefault]);

  const handleRadioSelectionChanges = (e, classOption) => {
    const scrollTop = e?.target?.parentNode?.parentNode?.parentNode?.scrollTop || 0;
    const { handleTabState, onRadioSelectionChange, handlePreferenceOptionIdToCheck } = props;
    const classOptionId = parseInt(classOption, 10);
    if (classOptionId !== classOption) {
      onRadioSelectionChange();
      handlePreferenceOptionIdToCheck(classOptionId);
    }
    handleTabState(
      classOptionId,
      slideIndex,
      scrollTop,
      props.bidSession
    );
    setClassOption(classOptionId);
  };

  const advanceScene = option => {
    if (
      props.modalScene === 2 &&
      props.classOption === option.preferenceOptionId
    ) {
      return props.handleScene();
    }
    return '';
  };

  const handleOptions = (classOptions, displayReserve) =>
    classOptions.map(option => {
      const label = (
        <span>
          <span>{option.name}</span>
          <br />
          <span style={{ fontSize: 'small' }}>{`${option.description}`}</span>
          {classOption === option.preferenceOptionId &&
            displayReserve &&
            displayReserveApi &&
            (props.displayScope || props.isCrewGroupDefault) &&
            props.optionPropertyId !== 15 &&
            !props.openCombinedPreferences && (
            <div className='reserve-down-to-wrapper'>
              <FormControlLabel
                control={
                  <DefaultCheckbox
                    checked={props.toggleReserved}
                    onChange={() => props.handleCheckboxChange()}
                  />
                }
                label={RESERVE_DOWN.RESERVE_DOWN_TO_LABEL} />
            </div>
            )}
          <div>{advanceScene(option)}</div>
        </span>
      );
      return (
        <FormControlLabel
          key={option.preferenceOptionId}
          value={option.preferenceOptionId}
          checked={classOption === option.preferenceOptionId}
          control={<RadioButton />}
          labelPlacement='end'
          label={label}
          className='option-class-radiobtn'
        />
      );
    });

    const handleEditOption = (classOptions, displayReserve) =>
      classOptions.map(option => {
        const isDisabled =
          classOption !== undefined &&
          classOption !== option.preferenceOptionId;

        const label = (
          <div className={`bid-option-container ${isDisabled ? 'disabled-radio' : ''}`}>
            <div className='bid-option-text'>
              <span className='bid-option-name'>{option.name}</span>
              <br />
              <span className='bid-option-description'>{option.description}</span>
            </div>
            <div>{advanceScene(option)}</div>
          </div>
        );

        return (
          <FormControlLabel
            key={option.preferenceOptionId}
            value={option.preferenceOptionId}
            checked={classOption === option.preferenceOptionId}
            disabled={isDisabled}
            control={<StyledRadioButton hidden={isDisabled} />}
            labelPlacement='end'
            label={label}
            className={`${isDisabled ? 'disabled-radio' : 'option-class-radiobtn'}`}
          />
        );
      }
    );

    const bidPreferenceClasses = props.bidPreferenceClasses
      ? props.bidPreferenceClasses
      : {};

    let displayReserve = false;
    if (
      bidPreferenceClasses.classOptionAttributes &&
      bidPreferenceClasses.classOptionAttributes.properties
    ) {
      if (
        bidPreferenceClasses.classOptionAttributes.properties.find(
          proprety => proprety.propertyId === 11
        )
      )
        displayReserve = true;
      else displayReserve = false;
    }
    let classTabs = [];
    if (bidPreferenceClasses.preferenceClasses) {
      const preferenceClasses = bidPreferenceClasses?.preferenceClasses?.entries;
      classTabs = preferenceClasses.map((entry, index) => {
        const isDisabled =
          props.editPrefFromCombinedPreferenceClassId !== null &&
          entry?.preferenceClassId !== props.editPrefFromCombinedPreferenceClassId;

        return {
          key: entry?.preferenceClassId,
          label: <p className={`bid-class-tab-label ${isDisabled ? 'disabled-tab' : ''}`}>{entry?.name}</p>,
          value: index,
          className: `bid-class-tab ${isDisabled ? 'disabled-tab' : ''}`,
          disabled: isDisabled,
          content: (
            <div className='bid-class-tab-content'>
              <RadioGroup
                key={entry?.preferenceClassId}
                name='classsOptions'
                onChange={handleRadioSelectionChanges}
                value={classOption}
              >
                <RadioButton value='0' style={{ display: 'none' }} />
                {!props.editPrefFromCombinedPreferenceClassId && handleOptions(entry?.options, displayReserve)}
                {props.editPrefFromCombinedPreferenceClassId && handleEditOption(entry?.options)}
              </RadioGroup>
            </div>
          )
        };
      });
    }

    return (
      <CustomSlider tabs={classTabs} openCombinedPreferences={props.openCombinedPreferences} editPrefFromCombinedPreferenceClassId={props.editPrefFromCombinedPreferenceClassId}/>
    );

}

BidClasses.defaultProps = {
  bidSession: {},
  bidPreferenceClasses: {},
  fetchBidPreferenceClasses: () => {},
  classOption: null,
  handleTabState: () => {},
  fetchClassOptionAttributes: () => {},
  resetRadio: () => {},
  slideIndex: 0,
  scrollTop: 0,
  handleScene: () => {},
  onRadioSelectionChange: () => {},
  modalScene: null,
  handleCheckboxChange: () => {},
  toggleReserved: false,
  reserveValue: 0,
  handleReserved: () => {},
  openCombinedPreferences: false,
  editPrefFromCombinedPreferenceClassId: null,
  displayScope: false
};

BidClasses.propTypes = {
  bidSession: PropTypes.object,
  bidPreferenceClasses: PropTypes.object,
  fetchBidPreferenceClasses: PropTypes.func,
  classOption: PropTypes.number,
  handleTabState: PropTypes.func.isRequired,
  fetchClassOptionAttributes: PropTypes.func.isRequired,
  resetRadio: PropTypes.func.isRequired,
  slideIndex: PropTypes.number.isRequired,
  scrollTop: PropTypes.number,
  optionPropertyId: PropTypes.number.isRequired,
  handleScene: PropTypes.func,
  onRadioSelectionChange: PropTypes.func,
  modalScene: PropTypes.number,
  handleCheckboxChange: PropTypes.func,
  toggleReserved: PropTypes.bool,
  reserveValue: PropTypes.number,
  handleReserved: PropTypes.func,
  displayScope: PropTypes.bool.isRequired,
  openCombinedPreferences: PropTypes.bool.isRequired,
  editPrefFromCombinedPreferenceClassId: PropTypes.number,
  isCrewGroupDefault: PropTypes.bool
};

const mapStateToProps = state => ({ ...state.bidPreferenceClasses });

const mapDispatchToProps = dispatch => ({
  fetchBidPreferenceClasses: (
    applicationType,
    optionPropertyId,
    categoryId,
    bidSessionId,
    staffId,
    openCombinedPreferences,
    isComponentMounted
  ) =>
    dispatch(
      actions.default.fetchBidPreferenceClasses(
        applicationType,
        optionPropertyId,
        categoryId,
        bidSessionId,
        staffId,
        openCombinedPreferences,
        isComponentMounted
      )
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(BidClasses);
